// extracted by mini-css-extract-plugin
export default {"DivContainer":"WingsCard_DivContainer__YgMub","InlineDiv":"WingsCard_InlineDiv__nKzya","Title":"WingsCard_Title__hxiEA"};